<style scoped lang="less">
/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}

.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #0acf97;

	.choiosvspde {
		/deep/ .el-button-group {
			width: 9rem;

			button:first-child {
				width: 7rem;
				height: 2rem;
				padding: 0 3px;
			}

			button:last-child {
				width: 1.6rem;
				height: 2rem;
				position: relative;
				padding: 0;
				top: 0px;
				left: 0px;
			}
		}
	}

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #0acf97;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiosvdate {
		width: 10rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiosipt {
		// width: 9rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		div {
			margin: 0 0.2rem;
		}

		.choiosipt {
			/deep/ .el-input--prefix .el-input__inner {
				height: 2rem;
				padding: 1rem 2rem;
			}

			/deep/ .el-input__prefix {
				top: -3px;
			}

			/deep/ .el-input__suffix {
				top: -3px;
			}
		}
	}
}

.orderstable {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #ab26aa;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar {
			width: 10px;
			height: 5px;
			// background: red;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			th {
				text-align: center;
			}

			td {
				button {
					color: #fff;
					border-radius: 5px;
				}

				.looking {
					background: #0d6efd;
					margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				.giveempower {
					background: #ff8300;

					span {
						font-size: 0.6rem;
					}
				}

				.giveempower:hover {
					background: #e17000;
				}

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #ab26aa;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #ab26aa;
			color: #fff;
		}
	}
}

.paginations {
	height: 3rem;
	line-height: 3rem;

	input {
		width: 3rem;
		height: 1.8rem;
		padding: 0 0 0 0.8rem;
		border: 1px solid #ccc;
	}
}
</style>
<template>
	<div>
		<titles titlename="日志管理" titlecontent="这里可以看到日志管理一些信息" :mbx="paths"></titles>
		<div class="choios">
			<div class="choiostitle">
				<button class="choiostitleleft "><span class="el-icon-wallet"></span></button>
				<div class="choiostitleright col-xs-8 col-sm-8 col-md-8 col-lg-8">
					<div class="choiosipt col-xs-4 col-sm-4 col-md-4 col-lg-4">
						<el-input @change="searchs()" placeholder="搜索" prefix-icon="el-icon-search" v-model="search"></el-input>
					</div>
					<div class="choiosvdate choiosipt"><el-date-picker @blur="stchangedate" v-model="vdate" type="date" placeholder="选择开始日期"></el-date-picker></div>
					<div class="choiosvdate choiosipt"><el-date-picker @blur="stchangedates" v-model="edates" type="date" placeholder="选择结束日期"></el-date-picker></div>
				</div>
			</div>

			<div class="orderstable">
				<p class="schooltitle">
					<!-- <span class="el-icon-s-management"></span> -->
					<span>日志管理</span>
				</p>
				<div class="paginations">
					每页显示
					<input @change="pagesizechanes()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table ref="multipleTable" header-row-class-name="tablestitle" tooltip-effect="dark" :data="tableData" border style="width: 100%">
							<el-table-column fixed type="selection" :resizable="false" width="55"></el-table-column>
							<el-table-column prop="ui_userName" label="记录人" width="150" :resizable="false">
								<template slot-scope="scope">
									<p :title="scope.row.ui_userName ?? scope.row.ui_guid">{{ scope.row.ui_userName ?? scope.row.ui_guid }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="log_typeName" :resizable="false" label="错误类型" width="100">
								<template slot-scope="scope">
									<p style="text-align: center;">{{ scope.row.log_typeName }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="log_fromName" width="200" :resizable="false" label="日志来源"></el-table-column>
							<el-table-column prop="log_errResult" :resizable="false" label="日志状态" width="80">
								<template slot-scope="scope">
									<p style="text-align: center;">{{ scope.row.log_isSuccess ? '成功' : '失败' }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="log_explain" :resizable="false" label="记录类型" width="120"></el-table-column>
							<el-table-column prop="log_errResult" :resizable="false" label="日志说明"></el-table-column>
							<el-table-column prop="log_createTime" width="170" :resizable="false" label="创建时间"></el-table-column>
							<el-table-column fixed="right" label="操作" :resizable="false" width="80">
								<template slot-scope="scope">
									<div class="userusec d-sm-none d-md-block">
										<el-button size="small" class="giveempower" @click="tabledeletes($event, scope.row)">
											删除
											<!-- 细节 -->
										</el-button>
									</div>
									<div class="userusec d-sm-block d-md-none">
										<el-dropdown trigger="click">
											<p class="el-dropdown-link">···</p>
											<el-dropdown-menu slot="dropdown">
												<el-button v-if="scope.row.zy == 0" size="small" class="delete" @click="tabledeletes($event, scope.row)">
													<span class="el-icon-delete" style="color: #fff;"></span>
												</el-button>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>

				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesize }}</span>
						,共
						<span>{{ pagggenums }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="pagesizes" :total="pagggenums"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { GetrzPageLogList, DeleteLog } from '@/request/api/dataorder/dataprder.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			pageindex: 1,
			pagesize: 10,
			pagggenums: 0,
			tabsnun: 10,
			// 搜索
			search: '',
			// 时间选择
			vdate: '',
			edate: '',
			sdate: '',
			edates: '',
			// 标题
			paths: [
				{
					path: '/system/logmange',
					name: '日志管理'
				}
			],
			tableData: [
				{
					classname: '系统错误',
					classtype: '登录模块',
					classtypes: '错误日志文字说明...',
					classmoude: '单机模式',
					angintime: '2022-07-20 13:30:00'
				},
				{
					classname: '系统错误',
					classtype: '登录模块',
					classtypes: '错误日志文字说明...',
					classmoude: '单机模式',
					angintime: '2022-07-20 13:30:00'
				},
				{
					classname: '系统错误',
					classtype: '登录模块',
					classtypes: '错误日志文字说明...',
					classmoude: '单机模式',
					angintime: '2022-07-20 13:30:00'
				}
			]
		};
	},
	components: {
		titles
	},
	mounted() {
		this.gfarzPageLogList();
	},
	computed: {
		pagesizes() {
			return Number(this.pagesize);
		}
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		pagesizechanes() {
			this.gfarzPageLogList();
		},
		// 时间筛选
		stchangedate() {
			// console.log(this.vdate)
			let stdate = this.changegodate(this.vdate ?? '');
			this.sdate = stdate;
			this.gfarzPageLogList();
		},
		stchangedates() {
			let edatees = this.changegodate(this.edates);
			this.edate = edatees;
			this.gfarzPageLogList();
		},

		// 快速装换
		changegodate(date) {
			console.log(date);
			let yy = new Date(date).getFullYear();
			let mm = new Date(date).getMonth() + 1;
			let dd = new Date(date).getDate();
			return yy + '/' + mm + '/' + dd;
		},

		tabledeletes(eve, itm) {
			DeleteLog(itm.log_guid).then(res => {
				console.log(res, '删除');
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.gfarzPageLogList();
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		searchs() {
			this.gfarzPageLogList();
		},
		handleCurrentChange(val) {
			this.pageindex = val;
			this.gfarzPageLogList();
		},
		gfarzPageLogList() {
			let rzPageobj = {
				pageIndex: this.pageindex,
				pageSize: this.pagesize,
				log_typeName: this.search,
				st: this.sdate,
				et: this.edate
			};
			GetrzPageLogList(rzPageobj).then(res => {
				console.log(res, '日志管理');
				this.tableData = res.data.data.list;
				this.pagggenums = res.data.data.totalCount;
			});
		},

		handleClick() {
			alert('button click');
		}
	}
};
</script>
